module.exports = __webpack_public_path__ + "img/banner-29.fbd25d2f.jpg";